import React from 'react';
import { Node } from './viewNode';

export const NodeGroup = (props: any) => {
	const { data, element, expandedIds, getClasses, baseClassNames, level, ...rest }: any = props;
	return (
		<ul
			role="group"
			className={getClasses(baseClassNames.nodeGroup)}
			style={{
				borderLeft: '1px solid var(--epods--color-border-light)',
				marginLeft: 'var(--epods--treeview-children-ul-margin)',
				paddingLeft: '25px',
				backgroundColor: 'var(--epods--color-bg)',
			}}
		>
			{expandedIds.has(element.id) &&
				element.children.map((x: any, index: number) => (
					<Node
						data={data}
						expandedIds={expandedIds}
						baseClassNames={baseClassNames}
						key={x}
						element={data[x]}
						setsize={element.children.length}
						posinset={index + 1}
						level={level + 1}
						{...rest}
					/>
				))}
		</ul>
	);
};
